const {isElectron} = require('react-device-detect');
import process from 'process';

/*TODO: немного костыльно, но другой способ получить состояние в этом месте пока не придумал*/
const serializedState = JSON.parse(localStorage.getItem('ComplexControlAppStorage'));

class ConfigApp {
    constructor(config) {
        for (let [key, value] of Object.entries(config)) {
            this[key] = value;
        }
    }
}

let settings = {};

if (isElectron) {
    try {
        const electron = require('electron');
        settings = electron.ipcRenderer.sendSync('get_conf');
    } catch (e) {
        console.error(e);
    }
} else {
    //appSettings.server_host = serializedState.appState.settings.server_host;
    appSettings.app_dir = './';
    appSettings.device_settings = {
        version: process.env.REACT_APP_VERSION,
        name: process.title,
        ip: '192.168.1.1'
    }
    settings = appSettings;
}

let configApp = new ConfigApp(settings);

export default configApp;